const SITE_URL = "https://kazhavda.mk";
const DEFAULT_OG_IMAGE =
  "https://kazhavda-public.s3.eu-central-1.amazonaws.com/og_image_kazhavda.png";
const FAVICON_URL =
  "https://kazhavda-public.s3.eu-central-1.amazonaws.com/kazhavda_favicon.ico";

function setMetaByName(name, content) {
  if (!name || !content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  if (!property || !content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(url) {
  if (!url) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function setLink(rel, href) {
  if (!rel || !href) return;
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

function ensureAbsoluteUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `${window.location.origin}${url.startsWith("/") ? "" : "/"}${url}`;
}

function truncate(text, maxLength = 160) {
  const value = String(text || "").trim();
  if (!value) return "";
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1)}…`;
}

export function applyDynamicSeo({
  title,
  description,
  imageUrl,
  keywords,
  type = "website",
  canonicalPath,
}) {
  const safeTitle = String(title || "Kazhavda | Wedding Planner");
  const safeDescription = truncate(
    description ||
      "kazhavDa е платформа за организирање свадба со алатки за гости, задачи, маси и инспирација."
  );
  const safeImage = ensureAbsoluteUrl(imageUrl || DEFAULT_OG_IMAGE);
  const canonicalUrl = canonicalPath
    ? `${SITE_URL}${canonicalPath}`
    : window.location.href;

  document.title = safeTitle;
  setCanonical(canonicalUrl);

  setMetaByName("description", safeDescription);
  setMetaByName("keywords", keywords || "свадба, wedding planner, kazhavda");
  setMetaByName("robots", "index,follow");

  setMetaByProperty("og:title", safeTitle);
  setMetaByProperty("og:description", safeDescription);
  setMetaByProperty("og:type", type);
  setMetaByProperty("og:url", canonicalUrl);
  setMetaByProperty("og:image", safeImage);
  setMetaByProperty("og:site_name", "Kazhavda");

  setMetaByName("twitter:card", "summary_large_image");
  setMetaByName("twitter:title", safeTitle);
  setMetaByName("twitter:description", safeDescription);
  setMetaByName("twitter:image", safeImage);

  setLink("icon", FAVICON_URL);
  setLink("shortcut icon", FAVICON_URL);
  setLink("apple-touch-icon", FAVICON_URL);
}

